import { up, down } from 'slide-element';
import announcer from './aria-announcer';

document.addEventListener('DOMContentLoaded', () => {
    const $searchButtons = document.querySelectorAll('.btn-search-toggle');
    const $searchBlock = document.querySelector('.block-search');
    const $body = document.body;

    if (!$searchButtons.length || !$searchBlock) return;

    let isOpen = $body.classList.contains('home');

    if (!isOpen) {
        $searchButtons.forEach((btn) => {
            btn.setAttribute('aria-expanded', 'false');
            btn.classList.remove('is-open');
        });
        $searchBlock.classList.remove('is-open');
        up($searchBlock, { immediate: true });
    }

    $searchButtons.forEach((button) => {
        button.addEventListener('click', () => {
            isOpen = !isOpen;

            $searchButtons.forEach((btn) => {
                btn.setAttribute('aria-expanded', String(isOpen));
                btn.classList.toggle('is-open', isOpen);
            });

            $searchBlock.classList.toggle('is-open', isOpen);

            if (isOpen) {
                const $mobileNavTrigger = document.querySelector('.mobile-nav-trigger');
                const $mobileMenu = document.querySelector('.mobile-menu');
                if ($mobileNavTrigger && $mobileMenu && $mobileNavTrigger.getAttribute('aria-expanded') === 'true') {
                    $mobileNavTrigger.setAttribute('aria-expanded', 'false');
                    up($mobileMenu);
                }

                down($searchBlock);
                announcer.announce('La recherche est ouverte');
            } else {
                up($searchBlock);
                announcer.announce('La recherche est fermée');
            }
        });
    });

    const $btnAdvancedSearch = document.querySelector('.btn-advanced-search');
    const $resultsPanel = document.querySelector('.block-search-panel');
    if (!$btnAdvancedSearch) return;

    const $advancedSearchPanel = document.querySelector('#block-advanced-search');
    const $label = $btnAdvancedSearch.querySelector('.label');
    const defaultText = 'Recherche avancée';
    const closeText = 'Fermer la recherche avancée';

    $btnAdvancedSearch.addEventListener('click', (e) => {
        e.preventDefault();
        const isExpanded = $btnAdvancedSearch.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
            up($advancedSearchPanel).then(() => {
                $btnAdvancedSearch.setAttribute('aria-expanded', 'false');
                $advancedSearchPanel.setAttribute('aria-hidden', 'true');
                $resultsPanel.classList.remove('panel-is-open');
                $label.textContent = defaultText;
                announcer.announce('Recherche avancée fermée');
            });
        } else {
            down($advancedSearchPanel).then(() => {
                $btnAdvancedSearch.setAttribute('aria-expanded', 'true');
                $advancedSearchPanel.setAttribute('aria-hidden', 'false');
                $resultsPanel.classList.add('panel-is-open');
                $label.textContent = closeText;
                announcer.announce('Recherche avancée ouverte');
                document.getElementById('exclude-word')?.focus();
            });
        }
    });
});
